import {CreateTypeOfControlSettingsRequestBody} from '@dms/teas';

const VALIDATION_OR_NON_VALIDATION_INSPECTION_TYPES = [
  CreateTypeOfControlSettingsRequestBody.inspectionType.VALIDATION_INSPECTION,
  CreateTypeOfControlSettingsRequestBody.inspectionType.NON_VALIDATION_INSPECTION,
];

export function getUpdatedInspectionType(
  type: CreateTypeOfControlSettingsRequestBody['inspectionType'],
  validationInspection: boolean
) {
  if (VALIDATION_OR_NON_VALIDATION_INSPECTION_TYPES.includes(type)) {
    return validationInspection
      ? CreateTypeOfControlSettingsRequestBody.inspectionType.VALIDATION_INSPECTION
      : CreateTypeOfControlSettingsRequestBody.inspectionType.NON_VALIDATION_INSPECTION;
  }
  return type;
}
